module.exports = __webpack_public_path__ + "img/118D-8.30.26307a72.png";